$(document).ready(function(){
  
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    var scrolled = $("#header").hasClass("scrolled");

    if(scroll > 200){
      $("#header").addClass("scrolled");
    } else {
      $("#header").removeClass("scrolled");
    }
  });
  
});


function openMenu(){
  $("#header .hamb").toggleClass("open");
  $("#menu-link").toggleClass("open");

  if($("#menu-link").hasClass("open")){
    $("#header").addClass("scrolled");
  }
}


function playTrailerVideo(id){
  $("#video-box-"+id+" .icon").fadeOut(200);  
  $("#video-box-"+id+" .background-video").fadeOut(200);  

  playVimeoVideo('trailer-'+id);
}

function playCorsoVideo(videoId){
  $("#corso-video-"+videoId+" .icon").fadeOut(200);  
  $("#corso-video-"+videoId+" .background-video").fadeOut(200);  

  playVimeoVideo('corso-'+videoId);
}

function playVimeoVideo(videoId){
  var iframe = document.getElementById(videoId);
  var player = new Vimeo.Player(iframe); 
  player.play();
}


function showServizi(servizio){
  $("#" + servizio).toggleClass("show-servizi")
}

